import {Injectable} from '@angular/core';
import {MatStepperIntl} from '@angular/material/stepper';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class MatStepperIntlNgxTranslateService extends MatStepperIntl {
  constructor(private readonly translate: TranslateService) {
    super();

    this.translate.onLangChange.subscribe(() => this.initialize());
    this.initialize();
  }

  initialize() {
    this.translate
      .get('m1+2.sprint9.stepper.optionalLabel')
      .subscribe(translation => (this.optionalLabel = translation));
  }
}
